import { render } from "./New_AttachmentKeywordTab.vue?vue&type=template&id=121e7828"
import script from "./New_AttachmentKeywordTab.vue?vue&type=script&lang=js"
export * from "./New_AttachmentKeywordTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__